// Types
import { ActionCreator } from 'redux';
import {
    EditorInstanceObject,
    RegisterTiptapEditorAction,
    SetTiptapActiveEditorAction,
    TiptapEditorStoreActions,
    TiptapEditorStoreState,
    UnregisterTiptapEditorAction,
} from './tiptapEditorStoreTypes';
import { Editor } from '@tiptap/react';
import { ThunkAction } from 'redux-thunk';

// Selectors
import { getActiveTiptapEditor } from './tiptapEditorSelectors';
import { getTiptapEditorById } from './tiptapEditorSelectors';

export const setActiveTiptapEditor: ActionCreator<SetTiptapActiveEditorAction, [Editor | null]> = (activeEditor) => ({
    type: 'SET_ACTIVE_TIPTAP_EDITOR',
    activeEditor,
});

export const registerTiptapEditor: ActionCreator<RegisterTiptapEditorAction, [string, Editor]> = (
    editorId,
    editor,
) => ({
    type: 'REGISTER_TIPTAP_EDITOR',
    editorId,
    editor,
});

export const unregisterTiptapEditor: ActionCreator<UnregisterTiptapEditorAction, [string, Editor]> = (
    editorId,
    editor,
) => ({
    type: 'UNREGISTER_TIPTAP_EDITOR',
    editorId,
    editor,
});

export const getActiveTiptapEditorThunk =
    (): ThunkAction<EditorInstanceObject | null, TiptapEditorStoreState, unknown, TiptapEditorStoreActions> =>
    (_, getTiptapEditorState) =>
        getActiveTiptapEditor(getTiptapEditorState());

export const getTiptapEditorByIdThunk =
    (
        editorId: string,
    ): ThunkAction<EditorInstanceObject | null, TiptapEditorStoreState, unknown, TiptapEditorStoreActions> =>
    (_, getTiptapEditorState) =>
        getTiptapEditorById(getTiptapEditorState(), editorId);
